// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__qdKyw","Support":"Footer_Support__m7UiY","Gallery":"Footer_Gallery__T_QF0","Auspices":"Footer_Auspices__GWVHV","Mangoweb":"Footer_Mangoweb__gXAEF"};